import { isValidPhoneNumber } from 'react-phone-number-input';
import z from 'zod';

import { INVALID_CONTACT_MESSAGE } from '@/components/Inputs/contactMessages';
import { GUEST_COUNT_ERRORS } from '@/store/invites/invites.mappers';

export const guestInvitationSchema = z.object({
  contact: z
    .string()
    .email(INVALID_CONTACT_MESSAGE)
    .or(
      z
        .string()
        .min(1, INVALID_CONTACT_MESSAGE)
        .refine((value) => isValidPhoneNumber(value), {
          message: INVALID_CONTACT_MESSAGE,
        }),
    ),
  name: z.string().min(1, 'Please enter a name.'),
});

export type InviteCrewMember = z.infer<typeof guestInvitationSchema>;

/** An invitation to an event, which may bring the guest's own guests along. */
export const eventGuestInvitationSchema = guestInvitationSchema.extend({
  additionalGuests: z
    .number({ error: GUEST_COUNT_ERRORS.empty })
    .int(GUEST_COUNT_ERRORS.notWhole)
    .min(0, GUEST_COUNT_ERRORS.negative),
});

export type EventGuestInvitation = z.infer<typeof eventGuestInvitationSchema>;
